import { Button } from "@/components/ui/button";
import { LogIn } from "lucide-react";

function Login() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex">
      <div className="flex-1 flex flex-col items-center justify-center p-8">
        <div className="w-full max-w-md space-y-8">
          <div className="text-center space-y-2">
            <h1 className="text-4xl sm:text-5xl tracking-tight font-extrabold">
              Finance Tracker
            </h1>
            <p className="text-base text-muted-foreground leading-relaxed">
              Track expenses, income, and savings with AI-powered insights
            </p>
          </div>

          <div className="space-y-4">
            <Button
              data-testid="google-login-button"
              onClick={handleLogin}
              className="w-full h-12 text-base font-semibold transition-transform duration-200 hover:-translate-y-px"
              size="lg"
            >
              <LogIn className="mr-2 h-5 w-5" />
              Sign in with Google
            </Button>
            <p className="text-xs text-muted-foreground text-center">
              Secure authentication powered by Emergent
            </p>
          </div>

          <div className="pt-8 space-y-4">
            <div className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground text-center">
              Features
            </div>
            <div className="grid gap-4">
              <div className="flex items-start gap-3 p-4 bg-card border border-border rounded-md">
                <div className="w-2 h-2 rounded-full bg-accent mt-1.5" />
                <div>
                  <div className="font-semibold text-sm">Multi-Currency Support</div>
                  <div className="text-xs text-muted-foreground">Track in USD, INR, or AED</div>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 bg-card border border-border rounded-md">
                <div className="w-2 h-2 rounded-full bg-success mt-1.5" />
                <div>
                  <div className="font-semibold text-sm">AI-Powered Insights</div>
                  <div className="text-xs text-muted-foreground">Get personalized financial recommendations</div>
                </div>
              </div>
              <div className="flex items-start gap-3 p-4 bg-card border border-border rounded-md">
                <div className="w-2 h-2 rounded-full bg-chart-4 mt-1.5" />
                <div>
                  <div className="font-semibold text-sm">Visual Analytics</div>
                  <div className="text-xs text-muted-foreground">Charts and trends for better understanding</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="hidden lg:flex flex-1 bg-cover bg-center"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGZpbmFuY2lhbCUyMGdyYXBoJTIwY2xlYW58ZW58MHx8fHwxNzgwMTI4NjE1fDA&ixlib=rb-4.1.0&q=85')"
        }}
      />
    </div>
  );
}

export default Login;